.container {
  width: 64rem;
  max-width: 100%;
  padding: 1.6rem;
}

.FormGroup {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: .8rem;
  margin-bottom: 1.6rem;

  > p {
    flex-grow: 1;
    text-align: right;
  }
}
